module.exports = __webpack_public_path__ + "static/19-aeb48af1092b22f36d1ac912f3aa1ef9.jpg";